import { Link } from '@remix-run/react'
import { cn } from '#app/utils/misc.tsx'
import { forwardRef } from 'react'
import { buttonVariants } from './button';

const HashLink = forwardRef<HTMLAnchorElement, { to: string; className?: string; variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "black" | "white" | null | undefined; size?: "default" | "wide" | "sm" | "lg" | "xl" | "pill" | "icon" | null | undefined; children?: React.ReactNode; }>(function HashLink(
  { to, className, variant = 'default', size = 'xl', ...props },
  ref,
) {
    const handleSmoothScroll = (e: React.MouseEvent) => {
        e.preventDefault();
        const selector = to;
        if (!selector) return;
        const target = document.querySelector(selector);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' })
        }
    }
    return (
        <Link
            to={to}
            className={cn(
                buttonVariants({ variant: variant, size: size }),
                className,
            )}
            ref={ref}
            onClick={handleSmoothScroll}
            {...props}
        />
    )
})

HashLink.displayName = 'HashLink'

export { HashLink }

const HashNavLink = forwardRef<HTMLAnchorElement, { to: string; className?: string; children?: React.ReactNode; closeMenu?: () => void }>(function HashNavLink(
    { to, className, children, closeMenu, ...props },
    ref,
    ) {
        const handleSmoothScroll = (e: React.MouseEvent) => {
            e.preventDefault();
            const selector = to;
            if (!selector) return;
            const target = document.querySelector(selector);
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' })
            }
            if (closeMenu) {
                setTimeout(() => {
                    closeMenu();
                }, 200);
            }
        }
        return (
            <Link
                to={to}
                className={className}
                ref={ref}
                onClick={handleSmoothScroll}
                {...props}
            >
                {children}
            </Link>
        )
    })

HashNavLink.displayName = 'HashNavLink'

export { HashNavLink }